import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindResumeGlowUpsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.FindResumeGlowUpsInput>;
}>;


export type FindResumeGlowUpsQuery = { __typename?: 'Query', resumeGlowUpQueries?: { __typename?: 'ResumeGlowUpQueries', findResumeGlowUps?: { __typename?: 'FindResumeGlowUpsPayload', completions: Array<{ __typename?: 'ResumeGlowUpCompletion', surface: Types.ResumeGlowUpSurface, completionCount: number, firstCompletedTimestamp: number, lastCompletedTimestamp: number }> } | null } | null };


export const FindResumeGlowUpsDocument = gql`
    query FindResumeGlowUps($input: FindResumeGlowUpsInput) {
  resumeGlowUpQueries {
    findResumeGlowUps(input: $input) {
      completions {
        surface
        completionCount
        firstCompletedTimestamp
        lastCompletedTimestamp
      }
    }
  }
}
    `;

/**
 * __useFindResumeGlowUpsQuery__
 *
 * To run a query within a React component, call `useFindResumeGlowUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindResumeGlowUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindResumeGlowUpsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindResumeGlowUpsQuery(baseOptions?: Apollo.QueryHookOptions<FindResumeGlowUpsQuery, FindResumeGlowUpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindResumeGlowUpsQuery, FindResumeGlowUpsQueryVariables>(FindResumeGlowUpsDocument, options);
      }
export function useFindResumeGlowUpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindResumeGlowUpsQuery, FindResumeGlowUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindResumeGlowUpsQuery, FindResumeGlowUpsQueryVariables>(FindResumeGlowUpsDocument, options);
        }
export function useFindResumeGlowUpsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindResumeGlowUpsQuery, FindResumeGlowUpsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindResumeGlowUpsQuery, FindResumeGlowUpsQueryVariables>(FindResumeGlowUpsDocument, options);
        }
export type FindResumeGlowUpsQueryHookResult = ReturnType<typeof useFindResumeGlowUpsQuery>;
export type FindResumeGlowUpsLazyQueryHookResult = ReturnType<typeof useFindResumeGlowUpsLazyQuery>;
export type FindResumeGlowUpsSuspenseQueryHookResult = ReturnType<typeof useFindResumeGlowUpsSuspenseQuery>;
export type FindResumeGlowUpsQueryResult = Apollo.QueryResult<FindResumeGlowUpsQuery, FindResumeGlowUpsQueryVariables>;